import { defHttp } from 'xmgoing-server';
import { getMenuListResultModel } from './model/menuModel';

enum Api {
  GetMenuList = '/pe-portal/resource/getCurUserMenu',
  GetSystemMenuList = '/pe-portal/adminResource/getSystemMenu',
  GetAdminMenuList= '/pe-portal/adminResource/getCurAdminMenu',
  GetSpaceMenusList= '/pe-portal/resource/getCurUserSpaceMenu',
}

/**
 * @description: Get user menu based on id
 */

export const getMenuList = (data: {name?: string} = {}) => {
  return defHttp.post<getMenuListResultModel>({ url: Api.GetMenuList, data });
};
export const getSystemMenuList = () => {
  return defHttp.post<getMenuListResultModel>({ url: Api.GetSystemMenuList });
};
export const getAdminMenuList = () => {
  return defHttp.post<getMenuListResultModel>({ url: Api.GetAdminMenuList });
};

/**
 * 根据空间id 获取菜单信息
 * @param spaceId
 */
export const getSpaceMenusAction =async (spaceId:string) => {
  return defHttp.get<getMenuListResultModel>({ params:{spaceId},url: Api.GetSpaceMenusList });
};
